<template>
  <label
    class="squircle-lg relative block cursor-pointer overflow-hidden rounded-lg border select-none"
    :class="{
      'bg-primary-50': !colorfull && !modelValue === trueValue,
      'bg-primary-50': colorfull && !modelValue === trueValue,
      'border-primary bg-primary-50': !colorfull && modelValue === trueValue,
      'border-primary bg-primary text-contrast-primary accent-white':
        colorfull && modelValue === trueValue,
      'p-1': size === 'extra-small',
      'p-2': size === 'small',
      'p-3': size === 'medium'
    }"
  >
    <div
      class="flex flex-row gap-1.5"
      :class="{
        'items-start': description?.length > 0,
        'items-center': !(description?.length > 0)
      }"
    >
      <div
        class="shrink-0"
        :class="{
          'pt-0.5': description?.length > 0,
          flex: !(description?.length > 0)
        }"
      >
        <input
          v-model="localModelValue"
          :class="{
            'text-primary': !colorfull,
            'text-primary-300': colorfull
          }"
          :disabled="!editionMode"
          :false-value="falseValue"
          :true-value="trueValue"
          class="text-primary rounded focus:ring-0 focus:ring-offset-0 active:ring-0 active:ring-offset-0"
          type="checkbox"
        />
      </div>
      <div class="flex flex-1 flex-col">
        <h3
          class="leading-tight font-semibold"
          :class="{
            'text-base': size === 'medium',
            'text-sm': size === 'small',
            'text-xs': size === 'extra-small'
          }"
        >
          {{ label }}
        </h3>
        <p v-if="description" class="text-xs empty:hidden">{{ description }}</p>
      </div>
    </div>
  </label>
</template>

<script>
export default {
  name: 'CheckBoxCardComponent',
  components: {},
  props: {
    modelValue: {
      type: [Array, String, Number, Boolean],
      required: true
    },
    label: {
      type: String,
      required: false,
      default: 'label'
    },
    description: {
      type: String,
      required: false,
      default: null
    },
    tinted: {
      type: Boolean,
      required: false,
      default: false
    },
    colorfull: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    trueValue: {
      type: [String, Number, Boolean],
      required: false,
      default: true
    },
    falseValue: {
      type: [String, Number, Boolean],
      required: false,
      default: false
    },
    editionMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['change', 'update:modelValue'],
  computed: {
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('change', value)
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>

<style scoped></style>
